import { useQuery } from '@tanstack/react-query';

import { api } from '../../shared/api/client';
import { queryKeys } from '../../shared/api/queryKeys';

/**
 * Справочник стилей (`GET /yoga-styles`).
 *
 * Не курсорная страница, в отличие от всех прочих списков панели (AD-A8), и это решение
 * контракта, а не упрощение здесь: набор пишется миграцией бэкенда и не растёт от
 * использования, поэтому ответ приходит одним телом без `nextCursor`.
 *
 * `staleTime` как у каталога ролей: набор меняется релизом бэкенда, а не действиями
 * администратора, и перечитывать его на каждый переход по разделам незачем.
 */
export function useYogaStyles() {
  return useQuery({
    queryKey: queryKeys.yogaStyles.all(),
    queryFn: () => api.get('/yoga-styles'),
    staleTime: 5 * 60_000,
  });
}
